﻿
angular.module('fliptoWeb')
    .directive('ftCanvasSlides', [function () {
        return {
            restrict: 'EA',
            require: "ftCanvasSlides",
            scope: {
            },
            bindToController: true,
            controllerAs: 'ftCanvasSlides',
            controller: ["$scope", "$element", function CanvasSlidesController($scope, $element) {
                
                const slideChangeInterval = 8000;
                this.slides = [];
                let activeSlideIndex = -1;
                this.add = function (slide) {
                    this.slides.push(slide);
                    if (angular.isDefined(slide.attrs.active)) {
                        this.setActive(slide);
                    }
                };
                this.setActive = function (newActiveSlide) {
                    $element.removeClass(`frame-${activeSlideIndex + 1}`);
                    this.slides.forEach(slide => { slide.active = false; });
                    newActiveSlide.active = true;
                    activeSlideIndex = this.slides.indexOf(newActiveSlide);
                    $element.addClass(`frame-${activeSlideIndex + 1}`);
                };

                this.removeActive = function (slide) {
                    slide.active = false;
                };
                
                this.moveUp = function () {
                    if (this.slides.length > activeSlideIndex + 1) {
                        this.setActive(this.slides[activeSlideIndex + 1]);
                        this.refreshInterval();
                    } else {
                        this.setActive(this.slides[0]);
                        this.refreshInterval();
                    }
                }

                this.moveDown = function() {
                    if (this.slides.length > 0 && activeSlideIndex - 1 >= 0) {
                        this.setActive(this.slides[activeSlideIndex - 1]);
                        this.refreshInterval();
                    } else {
                        this.setActive(this.slides[this.slides.length - 1]);
                        this.refreshInterval();
                    }
                }

                this.intervalId = null;

                this.refreshInterval = () => {
                    this.clearInterval();
                    this.intervalId = setInterval(() => {
                        $scope.$apply(() => this.moveUp());
                    }, slideChangeInterval);
                }

                this.clearInterval = function() {
                    clearInterval(this.intervalId);
                };

                this.refreshInterval();
                
                $scope.$on("$destroy", () => {
                    clearInterval(this.intervalId);
                });

            }]
        };
    }])
    .directive('ftCanvasSlide', [function () {
        return {
            restrict: 'EA',
            require: '^ftCanvasSlides',
            link: function (scope, elem, attrs, ctrl) {

                let slide = {
                    elem: elem,
                    attrs: attrs,
                    active: false
                };

                scope.$watch(() => slide.active, isActive => {
                    toggleActiveClass(isActive);
                }, true);
                ctrl.add(slide);
                
                function toggleActiveClass(isOn) {
                    if (isOn) {
                        elem.addClass("active");
                    } else {
                        elem.removeClass("active");
                    }
                }
            }
        };
    }])
    .directive('ftCanvasSlidesMoveUp', [function () {
        return {
            restrict: 'EA',
            require: '^ftCanvasSlides',
            link: function (scope, elem, attrs, ctrl) {

                elem.on("click", moveUp);

                function moveUp() {
                    scope.$apply(() => {
                        ctrl.moveUp();
                        ctrl.clearInterval();
                    });
                }

                scope.$on("$destroy",
                    () => {
                        elem.off("click", moveUp);
                    });
                
            }
        };
    }])
    .directive('ftCanvasSlidesMoveDown', [function () {
        return {
            restrict: 'EA',
            require: '^ftCanvasSlides',
            link: function (scope, elem, attrs, ctrl) {

                elem.on("click", moveDown);

                function moveDown() {
                    scope.$apply(() => {
                        ctrl.moveDown();
                        ctrl.clearInterval();
                    });
                }

                scope.$on("$destroy",
                    () => {
                        elem.off("click", moveDown);
                    });
                
            }
        };
    }]);